module.exports = __webpack_public_path__ + "static/img/zanwu.6b9f66b5.png";